<template>
  <modal
    v-model="visible"
    :overflow="'hidden'"
  >
    <tabs-component
      v-model="currentKey"
      :tabs="tabs"
    />

    <keep-alive>
      <component :is="currentComponent" />
    </keep-alive>
  </modal>
</template>

<script>
import AssignRolesComponent from './SecurityAssignRoles.vue';
import AssignPermissionsComponent from './SecurityAssignPermissions.vue';
import ViewPermissionsComponent from './SecurityViewPermissions.vue';
import Tabs from 'library/components/reusable/input/Tabs.vue';
import Modal from 'library/components/reusable/containers/Modal.vue';
export default {
  components: {
    'assign-roles-component': AssignRolesComponent,
    'assign-permissions-component': AssignPermissionsComponent,
    'view-permissions-component': ViewPermissionsComponent,
    'tabs-component': Tabs,
    modal: Modal,
  },
  data() {
    return {
      visible: false,
      tabs: [
        {
          key: 0,
          text: 'Assign Roles',
          component: 'assign-roles-component',
        },
        {
          key: 1,
          text: 'Assign Permissions',
          component: 'assign-permissions-component',
        },
        {
          key: 2,
          text: 'View Permissions',
          component: 'view-permissions-component',
        },
      ],
      currentKey: 0,
    };
  },

  computed: {
    currentComponent: function () {
      return this.tabs.find((t) => t.key === this.currentKey).component;
    },
  },
  methods: {
    open(tabKey) {
      this.visible = true;
      this.currentKey = this.tabs.find((t) => t.key === tabKey).key;
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .modal-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 50% !important;
  height: 70% !important;

  #container {
    display: flex;
    max-height: 100%;
    width: 100%;
    overflow: hidden;
    padding: 10px;

    .column {
      display: flex;
      flex-direction: column;
      max-height: 100%;
      width: 50%;

      .multitoggle {
        margin-bottom: 10px;
      }

      #current {
        margin: 10px 7px;
      }

      &:first-child {
        margin-right: 10px;
      }

      .master-list {
        display: flex;
        flex-direction: column;
        max-height: 100%;
        overflow-y: auto;
        border: 1px solid #d7d7d7;

        .group {
          padding: 10px 7px;
          color: black;
          list-style-type: none;
          vertical-align: middle;
          background-color: #d8d8d8;
          font-weight: bolder;
          cursor: default !important;
        }
        .child {
          padding: 7px 10px;
          font-weight: lighter;
          cursor: default !important;

          &:nth-child(even) {
            background-color: #f7f7f7;
          }

          &.hoverable:hover:not(.selected) {
            background-color: #dedede;
          }
          &.row {
            display: flex;
            flex-shrink: 0;
            align-items: center;
          }
          &.user {
            justify-content: space-between;
          }

          &.selected {
            background: #003263;
            color: white;
          }

          .disabled {
            color: #a6a6a6;
          }

          .check-container {
            display: flex;
            align-items: center;
            span {
              margin-left: 10px;
            }
          }
        }
      }

      .single-group {
        padding: 10px 7px;
        color: black;
        list-style-type: none;
        vertical-align: middle;
        background-color: #d8d8d8;
        font-weight: bolder;
        cursor: default !important;
      }
    }
  }
}
</style>
